import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from '@/types/utils';

export enum PermissionGroupEnum {
  ADMIN = 'ADMIN',
  USER = 'USER'
}
export class IPostUserXDockPermissionsBodyDto {
  userId: number;
  pointId: number;
  permissionGroup: PermissionGroupEnum;
}

export class IPatchUserXDockPermissionsBodyDto {
  pointId: number;
  permissionGroup: PermissionGroupEnum;
}

export class UserXDockPermission {
  id: number;
  userId: number;
  pointId: number;
  permissionGroup: PermissionGroupEnum;
}

export class IUserXDockPermissionResponse {
  @Type(() => UserXDockPermission)
  result: UserXDockPermission;
}

export class IUserXDockPermissionListResponse extends IPagination {
  @Type(() => UserXDockPermission)
  results: UserXDockPermission[];
}

export class IUserXDockpermissionsQueryDto extends IQueryPaginationDto {
  userId?: string;
}
